import { selectLookupSahCategories } from 'tsx/features/lookups/selectors/sahCategories';

import { YesNoAllOptions } from '~constants/maps';

import { SearchProps } from '~components/form-fields/search';

import { SahService } from '~lookups/models';

import { selectLookupAppointmentServiceTypes } from '~appointments/selectors/serviceTypes';

export const createSearchFields = (sahServices: SahService[]): SearchProps => ({
  category_id: {
    persist: true,
    type: 'multi-lookup',
    field: 'category_id',
    caption: 'Category',
    placeholder: 'All',
    selectorOptions: selectLookupSahCategories,
  },
  sah_service: {
    persist: true,
    type: 'multi-lookup',
    field: 'sah_service_id',
    caption: 'SAH Service',
    placeholder: 'All',
    options: sahServices,
  },
  service_type: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'service_type_id',
    caption: 'Service Type',
    placeholder: 'All',
    selectorOptions: selectLookupAppointmentServiceTypes,
  },
  show_current: {
    defaultShow: false,
    type: 'lookup',
    field: 'show_current',
    caption: 'Show Only Current Associations?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
});
